const main_view = {
    template: require('./view.html'),
    controller: [
        '$scope',
        'life_time_api',
        'chartFilters',
        function($scope, life_time_api, chartFilters) {
            function update_ltv_table(model) {
                life_time_api.by_mission(model).then(rows => $scope.rows = rows);
            }
            var model = chartFilters.get_chart_filters();
            if (model.filters.missions) {
                update_ltv_table(model);
            }
            chartFilters.onChangeChartParams('update_ltv_table', update_ltv_table);
            $scope.rows = [];
        },
    ],
};
const state_config = {
    url: '/by_mission',
    reloadOnSearch: false,
    data: {
        priority: 900,
        title: 'by Mission',
    },
    views: {
        '': main_view,
        'main-filter@amt.ww2': require('ww2_analytics/segments/missions_form'),
    },
};
export default state_config;
